<script setup>
definePageMeta({
  layout: "page",
});
const route = useRoute()
const { getLeadGenLocal, setLeadGenLocal, leadGenData, getBrochureRequestPage } = useLeadGenData();
const { data: leadGen } = await leadGenData();
const { data: pageSettings } = await getBrochureRequestPage();
const {setPageHead} = useGlobalFeaturesData();
const {sanitize} = useUtils();


const leadGenFields = leadGen.value.leadGenFields;
const displayJumpToTop = pageSettings.value.jumpToTop;
const customHeroHeader = (pageSettings.value && !!pageSettings.value.heroHeader)? pageSettings.value.heroHeader : null;
const overrideHeroHeader = customHeroHeader !== null;
const displayHeroHeader = pageSettings.value.displayHero;
const showChatService = pageSettings.value.showChatService;

// Set meta tags in head for SEO
if(pageSettings.value && pageSettings.value.seo) {
  setPageHead(sanitize(pageSettings.value.seo), route.path)
}
</script>
<template>
  <LayoutHeroHeader v-if="!overrideHeroHeader && displayHeroHeader" />
  <LayoutHeroHeader :heroHeader="customHeroHeader" v-if="overrideHeroHeader && displayHeroHeader" />
  <div class="main">
    <div class="blocks">
      <div class="block ">
        <div class="container">          
          <div class="row justify-content-center text-center mb-6 mt-3">
            <div class="col-9 ">
              <UIHeading
                :titleComponent="pageSettings.title"
                :subtitleClass="'subtitle'" />              
            </div>
          </div>
          <FormBrochureRequest :leadGenFields="leadGenFields" :pageSettings="pageSettings" />
        </div>
      </div>
    </div>
  </div>
  <LayoutBackToTop v-if="displayJumpToTop"/>
  <ChatService v-if="showChatService"/>
</template>

